// extracted by mini-css-extract-plugin
export default {"container":"switch_container__pJozS","label":"switch_label__9NrxZ","track":"switch_track__-vioJ","selected":"switch_selected__htD5W","thumb":"switch_thumb__WuiAe"};